
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/TermsOfService",
      function () {
        return require("private-next-pages/TermsOfService.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/TermsOfService"])
      });
    }
  